<template>
  <section class="contact">
    <container>
      <div class="contact__person">
        <div class="contact__person__split">
          <div class="contact__person__split__item">
            <div class="contact__person__detail contact__person__detail--title">Ihr Ansprechpartner</div>
          </div>
          <div class="contact__person__split__item">
            <div class="contact__person__detail contact__person__detail--email">{{ content.email }}</div>
          </div>
        </div>
        <div class="contact__person__split">
          <div class="contact__person__split__item">
            <div class="contact__person__detail contact__person__detail--name">{{ content.name }}</div>
          </div>
          <div class="contact__person__split__item">
            <div class="contact__person__detail contact__person__detail--phone">{{ content.phone }}</div>
          </div>
        </div>
      </div>
    </container>
  </section>
</template>

<script>
  import {api} from '@/main.js'
  import Container from "@/components/container/index";
  export default {
    name: 'OnepageContact',
    components: {Container},
    data () {
      return {
        content: false
      }
    },
    mounted () {
      api.singleton.get('contact').then(response => {
        this.content = JSON.parse(response.data)
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .contact {
    background: $background-dark;
    color: $text-inverse;

    &__person {
      padding: 1rem 2rem;

      &__split {
        display: flex;
        justify-content: center;
        align-items: center;

        &__item {
          width: 45%;
          padding: 1rem 0;
        }
      }

      &__detail {
        &--title {
          font-size: $size_text-big * 1;
        }
        &--name {
          font-weight: bold;
          font-size: $size_text-big * 1.75;
        }
        &--phone {
          text-align: right;
          font-size: $size_text-big * 1.25;
        }
        &--email {
          text-align: right;
          font-size: $size_text-big * 1.25;
        }
      }
    }

    @media (max-width: 777px) {
      &__person {
        display: flex;
        flex-direction: column;

        &__split {
          flex-direction: column;

          &__item {
            width: 100%;
          }

          & + & {
            flex-direction: column-reverse;
          }
        }

        &__detail {
          text-align: center !important
        }
      }
    }
  }


//////////////////////////////////////////////
  .contact--old {
    background: $background-dark;
    color: $text-inverse;

    &__title {
      margin: $spacing_title;
      line-height: 1;
      font-size: $size_title-big;
    }
    &__split {
      display: flex;

      &__form {
        width: 60%;
      }
      &__person {
        width: 40%;
      }
    }

    &__form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      input, textarea {
        font-size: 1.25rem;
        background: #fff;
        border: 2px solid $gray;
        display: block;
        padding: .5rem .75rem;
        border-radius: 6px;
        text-decoration: none;
        margin-top: .75rem;
      }

      input {
        width: 49%;
      }
      textarea {
        width: 100%;
      }
      input[type="submit"] {
        width: 25%;
        background: darken($gray, 5);
        border-color: darken($gray, 5);

        &:hover,
        &:focus {
          cursor: pointer;
          background: $gray;
          border-color: $gray;
        }
      }
    }
    &__person {
      padding: 1rem 2rem;
      font-size: $size_text;

      &__name {
        display: block;
        font-size: $size_text-big;
      }

      $cache: &;
      &__detail {
        display: block;
        padding: .125rem 0;

        & + & {
          padding-top: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/onepage/contact.vue